import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faHome } from '@fortawesome/free-solid-svg-icons';

const TilesSkeletonLoader = () => {
  return (
    <div className="flex-1 bg-gray-50 min-h-screen">
      {/* Header Skeleton */}
      <div className="bg-white sticky top-0 z-50 border-b border-gray-200">
        <div className="h-1 bg-gradient-to-r"></div>
        <div className="px-4 py-3">
          <div className="flex items-center justify-between gap-3">
            {/* Back Button */}
            <div className="flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-red-50 to-white rounded-xl">
              {/* Replace FontAwesomeIcon with animated div */}
              <div className="w-5 h-5 bg-gray-200 animate-pulse rounded-md"></div>
            </div>
            </div>

            {/* Project Name and Category Container */}
            <div className="flex-1 flex flex-col items-center">
              <div className="h-6 w-48 bg-gray-200 animate-pulse rounded-md mb-0.5"></div>
              <div className="flex items-center gap-1.5">
                <div className="w-1 h-1 "></div>
                <div className="h-4 w-12 bg-gray-200 animate-pulse rounded-md"></div>
                <div className="w-1 h-1 "></div>
              </div>
            </div>

            {/* Home Button */}
            <div className="flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-red-50 to-white rounded-xl">
                {/* Replace FontAwesomeIcon with animated div */}
                <div className="w-5 h-5 bg-gray-200 animate-pulse rounded-md"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Skeleton */}
      <div className="bg-[#F5F7FA] flex-1 p-0.1 pt-0.1 -mt-5 overflow-y-auto">
        <div className="bg-gray-100 rounded-lg shadow-md">
          <div className="p-4">
            {/* Render multiple category skeletons */}
            {[1, 2, 3].map((item) => (
              <div key={item} className="mx-0 mt-4 lg:mx-8 bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                {/* Category Header Skeleton */}
                <div className="p-2 border-b border-gray-100">
                  <div className="flex justify-between items-center">
                    <div className="h-6 w-32 bg-gray-200 animate-pulse rounded-md"></div>
                    <div className="h-5 w-20 bg-gray-200 animate-pulse rounded-md"></div>
                  </div>
                </div>

                {/* Product Skeleton */}
                <div className="p-2">
                  <div className="flex justify-between items-center mb-2">
                    <div className="h-5 w-40 bg-gray-200 animate-pulse rounded-md"></div>
                    <div className="h-6 w-20 bg-gray-200 animate-pulse rounded-md"></div>
                  </div>

                  <div className="mt-1 bg-gray-50 rounded-lg p-3 shadow-sm">
                    <div className="grid grid-cols-3 gap-4">
                      <div className="flex flex-col">
                        <div className="h-3 w-16 bg-gray-200 animate-pulse rounded-md mb-2"></div>
                        <div className="h-4 w-20 bg-gray-200 animate-pulse rounded-md"></div>
                      </div>

                      <div className="flex flex-col text-center">
                        <div className="h-3 w-16 bg-gray-200 animate-pulse rounded-md mb-2 mx-auto"></div>
                        <div className="h-4 w-24 bg-gray-200 animate-pulse rounded-md mx-auto"></div>
                      </div>

                      <div className="flex flex-col text-right">
                        <div className="h-3 w-12 bg-gray-200 animate-pulse rounded-md mb-2 ml-auto"></div>
                        <div className="h-5 w-20 bg-gray-200 animate-pulse rounded-md ml-auto"></div>
                      </div>
                    </div>

                    <div className="flex items-center justify-between mt-3 pt-2 border-t border-gray-200">
                      <div className="h-8 w-28 bg-gray-200 animate-pulse rounded-lg"></div>
                      <div className="h-8 w-24 bg-gray-200 animate-pulse rounded-lg"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Package Options Skeleton */}
            <div className="p-5 mt-6 mb-16 bg-white rounded-xl shadow-sm border border-gray-100">
              <div className="flex items-center gap-3 mb-5">
                <div className="bg-red-100 p-2 rounded-lg">
                  <div className="h-5 w-5 bg-gray-200 animate-pulse rounded-md"></div>
                </div>
                <div className="h-5 w-40 bg-gray-200 animate-pulse rounded-md"></div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                {[1, 2].map((item) => (
                  <div key={item} className="group relative overflow-hidden flex flex-col p-4 bg-white border border-gray-200 rounded-xl">
                    <div className="h-6 w-32 bg-gray-200 animate-pulse rounded-md mb-3"></div>
                    <div className="flex items-center justify-between">
                      <div className="h-5 w-24 bg-gray-200 animate-pulse rounded-md"></div>
                      <div className="h-5 w-5 bg-gray-200 animate-pulse rounded-md"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Floating Button Skeleton */}
      <div className="fixed bottom-0 w-full bg-white border-t border-gray-200 shadow-xl z-10">
        <div className="px-4 py-3">
          <div className="flex items-center justify-between w-full gap-3">
            <div className="w-[30%] h-[48px] bg-gray-200 animate-pulse rounded-lg"></div>
            <div className="w-[70%] h-[48px] bg-gray-200 animate-pulse rounded-lg"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TilesSkeletonLoader;
